import type { Pro20User } from '@/features/auth/types/auth.types';

/** Resolves a safe display name from a PRO20 user (handles legacy persisted shapes) */
export function getDisplayName(user: Pro20User | null | undefined): string {
  if (!user) return 'User';

  if (user.name?.trim()) {
    return user.name.trim();
  }

  if (user.userCode.trim()) {
    return user.userCode.trim();
  }

  if (user.email.trim()) {
    return user.email.trim();
  }

  return 'User';
}

export function getFirstName(user: Pro20User | null | undefined): string {
  const displayName = getDisplayName(user);
  return displayName.split(' ')[0] ?? displayName;
}
